import { render } from "./EquipmentSummaryItem.vue?vue&type=template&id=4facd04d"
import script from "./EquipmentSummaryItem.vue?vue&type=script&lang=ts"
export * from "./EquipmentSummaryItem.vue?vue&type=script&lang=ts"
script.render = render

export default script